import Vue from 'vue';
import Router from 'vue-router';

import Home from '../views/Home';

Vue.use(Router);

const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
    return routerPush.call(this, location).catch(error => error);
};

const router = new Router({
    base: process.env.BASE_URL,
    mode: 'history',
    routes: [
        {
            path: '/',
            component: Home,
        },
        {
            path: '/login',
            component: () => import('../views/Login'),
        },
        {
            path: '/register',
            component: () => import('../views/Register'),
        },
        {
            path: '/search',
            component: () => import('../views/Search'),
        },
        {
            path: '/materSearch',
            component: () => import('../views/materSearch'),
        },
        {
            path: '/introduce/:category',
            component: () => import('../views/Introduce'),
            meta: {
                showBreadCrumb: true,
                name: 'auto',
            },
        },
        {
            path: '/introduce/:id',
            component: () => import('../views/Introduce'),
            meta: {
                showBreadCrumb: true,
                name: '内容',
            },
        },
        {
            path: '/contactUs',
            component: () => import('../views/ContactUs'),
            meta: {
                showBreadCrumb: true,
                name: '联系我们',
            },
        },
        {
            path: '/shopcart',
            component: () => import('../views/ShopCart'),
            meta: {
                showBreadCrumb: true,
                name: '购物车',
            },
        },
        {
            path: '/sub-order',
            component: () => import('../views/SubOrder'),
            meta: {
                showBreadCrumb: true,
                name: '确认订单',
            },
        },
        {
            name: 'payorder',
            path: '/pay-order',
            component: () => import('../views/PayOrder'),
            meta: {
                showBreadCrumb: true,
                name: '订单支付',
            },
        },
        {
            name: 'cspayorder',
            path: '/cs-pay-order',
            component: () => import('../views/CsPayOrder'),
            meta: {
                showBreadCrumb: true,
                name: '订单支付',
            },
        },
        {
            path: '/center',
            meta: {
                showBreadCrumb: true,
                name: '个人中心',
            },
            component: () => import('../views/Center'),
            children: [
                {
                    component: () => import('../views/center/Order'),
                    path: '/center/order',
                    meta: {
                        showBreadCrumb: true,
                        name: '我的订单',
                    },
                },
                {
                    component: () => import('../views/center/orderDetail'),
                    path: '/center/orderDetail',
                    meta: {
                        showBreadCrumb: true,
                        name: '订单明细',
                    },
                },
                {
                    component: () => import('../views/center/ShipPaging'),
                    path: '/center/shipPaging',
                    meta: {
                        showBreadCrumb: true,
                        name: '已发货列表',
                    },
                },
                {
                    component: () => import('../views/center/waitInvoice'),
                    path: '/center/waitInvoice',
                    meta: {
                        showBreadCrumb: true,
                        name: '待开票列表',
                    },
                },
                {
                    component: () => import('../views/center/InvoicePaging'),
                    path: '/center/invoicePaging',
                    meta: {
                        showBreadCrumb: true,
                        name: '已开票列表',
                    },
                },
                {
                    component: () => import('../views/center/Money'),
                    path: '/center/money',
                    meta: {
                        showBreadCrumb: true,
                        name: '我的预存款',
                    },
                },
                {
                    component: () => import('../views/center/Address'),
                    path: '/center/address',
                    meta: {
                        showBreadCrumb: true,
                        name: '我的地址',
                    },
                },
                {
                    component: () => import('../views/center/Invoceaddress'),
                    path: '/center/invoceaddress',
                    meta: {
                        showBreadCrumb: true,
                        name: '我的收票地址',
                    },
                },
                {
                    component: () => import('../views/center/UserInvoice'),
                    path: '/center/user-invoice',
                    meta: {
                        showBreadCrumb: true,
                        name: '我的开票信息',
                    },
                },
                {
                    component: () => import('../views/center/UserInfo'),
                    path: '/center/userinfo',
                    meta: {
                        showBreadCrumb: true,
                        name: '我的信息',
                    },
                },
                {
                    component: () => import('../views/center/AfterSale'),
                    path: '/center/afterSale',
                    meta: {
                        showBreadCrumb: true,
                        name: '售后反馈',
                    },
                },
                {
                    component: () => import('../views/center/Password'),
                    path: '/center/passWord',
                    meta: {
                        showBreadCrumb: true,
                        name: '修改密码',
                    },
                },
                {
                    component: () => import('../views/center/SunAccount'),
                    path: '/center/sunAccount',
                    meta: {
                        showBreadCrumb: true,
                        name: '子账号列表',
                    },
                },
            ],
        },
        {
            path: '/brand',
            component: () => import('../views/brandList'),
            meta: {
                showBreadCrumb: true,
                name: '品牌中心',
            },
        },
        {
            path: '/product-detail/:id',
            component: () => import('../views/ProductDetail'),
            meta: {
                showBreadCrumb: true,
                name: '商品详情',
            },
        },
        {
            path: '/product-list/:id',
            component: () => import('../views/ProductList'),
        },
        {
            path: '/paySuccess',
            component: () => import('../views/paySuccess'),
        },
        {
            path: '/zcxy',
            component: () => import('../views/Zcxy'),
        },
        {
            path: '/xsfw',
            component: () => import('../views/Xsfw'),
        },
    ],
});

router.beforeEach((to, from, next) => {
    if (to.fullPath === '/login') {
        localStorage.setItem('lastPath', from.fullPath);
    }
    next();
});

export default router;
